"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeType = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireWildcard(require("./Input"));

var _VerifyCodeBtn = _interopRequireDefault(require("../VerifyCodeBtn"));

var _VoiceCode = _interopRequireDefault(require("../VoiceCode"));

// 手机号验证码登录模块（手机号组件 + 验证码组件）

/* eslint-disable jsx-a11y/anchor-is-valid, */
let CodeType;
exports.CodeType = CodeType;

(function (CodeType) {
  CodeType["TEXT"] = "text";
  CodeType["VOICE"] = "voice";
})(CodeType || (exports.CodeType = CodeType = {}));

class PhoneCodeFrom extends _react.default.PureComponent {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      verifyCodeEnable: false,
      showVoiceCode: false,
      // 是否展示语音验证码
      isSendVoiceCode: false,
      // 发送语音验证码
      isShowVoiceSendTips: false,
      telErrorTips: '',
      passErrorTips: ''
    });
    (0, _defineProperty2.default)(this, "codeInputRef", void 0);
    (0, _defineProperty2.default)(this, "phoneInputRef", void 0);
    (0, _defineProperty2.default)(this, "onPhoneInput", (val, validInfo) => {
      const onPhoneInput = this.props.onPhoneInput;
      onPhoneInput(val, validInfo); // onPhoneInput(val);

      this.setState({
        verifyCodeEnable: Boolean(val && validInfo.valid)
      });
    });
    (0, _defineProperty2.default)(this, "onCodeInput", (val, validInfo) => {
      const onCodeInput = this.props.onCodeInput;
      onCodeInput(val, validInfo);
    });
    (0, _defineProperty2.default)(this, "getCode", codeType => {
      this.codeInputRef.current.input.focus();
      const _this$props = this.props,
            scene = _this$props.scene,
            phone = _this$props.phone;
      return this.props.getCode({
        phone_number: phone,
        scene,
        code_type: codeType
      });
    });
    (0, _defineProperty2.default)(this, "onClickVoice", () => {
      this.setState({
        isShowVoiceSendTips: true
      });
      setTimeout(() => {
        this.setState(() => {
          isShowVoiceSendTips: false;
        });
      });
    });
    (0, _defineProperty2.default)(this, "setErrorTips", (tips, type) => {
      if (type === 'tel') {
        this.setState({
          telErrorTips: tips
        });
      } else {
        this.setState({
          passErrorTips: tips
        });
      }
    });
    (0, _defineProperty2.default)(this, "onCountChange", remainSec => {
      const showVoiceCode = this.state.showVoiceCode;

      if (!showVoiceCode && remainSec <= 30) {
        this.showVoiceCodeText();
      }
    });
    (0, _defineProperty2.default)(this, "showVoiceCodeText", () => {
      this.setState({
        showVoiceCode: true
      });
    });
    const _phone = props.phone;
    this.setState({
      verifyCodeEnable: Boolean(_phone && (0, _Input.validate)(_phone, 'phoneNumber'))
    });
    this.codeInputRef = /*#__PURE__*/_react.default.createRef();
    this.phoneInputRef = /*#__PURE__*/_react.default.createRef();
  }

  render() {
    const _this$props2 = this.props,
          phone = _this$props2.phone,
          code = _this$props2.code,
          loginTypeError = _this$props2.loginTypeError,
          setLoginTypeError = _this$props2.setLoginTypeError;
    const _this$state = this.state,
          verifyCodeEnable = _this$state.verifyCodeEnable,
          showVoiceCode = _this$state.showVoiceCode,
          isSendVoiceCode = _this$state.isSendVoiceCode,
          telErrorTips = _this$state.telErrorTips,
          passErrorTips = _this$state.passErrorTips,
          isShowVoiceSendTips = _this$state.isShowVoiceSendTips;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "phone-form",
      "data-modid": "phone_input"
    }, /*#__PURE__*/_react.default.createElement(_Input.default, {
      ref: this.phoneInputRef,
      type: "tel",
      name: "phone",
      value: phone,
      key: "codeFormPhone",
      validateType: "phoneNumber",
      placeholder: "\u624B\u673A\u53F7",
      onInput: this.onPhoneInput,
      maxLength: 11,
      className: "phone-number",
      btnDescription: "\u53D1\u9001\u9A8C\u8BC1\u7801",
      loginTypeError: loginTypeError,
      setLoginTypeError: setLoginTypeError,
      setErrorTips: this.setErrorTips
    }, /*#__PURE__*/_react.default.createElement(_VerifyCodeBtn.default, {
      enable: verifyCodeEnable,
      onClick: () => {
        this.getCode(CodeType.TEXT);
      },
      onCountChange: this.onCountChange
    })), /*#__PURE__*/_react.default.createElement(_Input.default, {
      ref: this.codeInputRef,
      type: "pass" // 这里用 number 会有 bug
      ,
      name: "code",
      value: code,
      key: "codeFormcode",
      validateType: "smsCode",
      placeholder: "\u9A8C\u8BC1\u7801",
      className: "ipt-code-wrap verification",
      onInput: this.onCodeInput,
      maxLength: 6,
      loginTypeError: loginTypeError,
      setLoginTypeError: setLoginTypeError,
      setErrorTips: this.setErrorTips
    }), (telErrorTips || passErrorTips) && /*#__PURE__*/_react.default.createElement("div", {
      className: "left"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "error-tips"
    }, telErrorTips || passErrorTips)), showVoiceCode && /*#__PURE__*/_react.default.createElement(_VoiceCode.default, {
      onClick: this.onClickVoice
    }), isShowVoiceSendTips && /*#__PURE__*/_react.default.createElement("div", {
      className: "tips"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "speech-tips"
    }, `我们将拨打 ${phone} 告知语音验证码`)));
  }

}

(0, _defineProperty2.default)(PhoneCodeFrom, "defaultProps", {
  phone: '',
  code: '',
  scene: 'k12_login',
  getCode: () => {},
  onPhoneInput: () => {},
  onCodeInput: () => {},
  loginTypeError: ''
});
var _default = PhoneCodeFrom;
exports.default = _default;